export default function YearBlock(props) {
  return (
    <div
      className={
        "w-6 h-6 rounded-sm transform hover:scale-125 " +
        (props.past
          ? "bg-yellow-300"
          : props.current
          ? "bg-green-500"
          : props.future
          ? "bg-blue-300"
          : "")
      }
    ></div>
  );
}
